export enum ETaskSourceType {
    Manual = 'manual',
    Call = 'call',
    Voicemail = 'voicemail',
    Sms = 'sms',
}
